
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { adminRolesAction } from "../../redux/actions/general-action";

// Store Information's sub-modules each have their own permission, nested under
// the parent in `hasItems`. Until a role carries an entry for one of them, it
// falls back to the shared permission the sub-module used before, so a backend
// without the entry behaves as it always has rather than locking everyone out.
const PERMISSION_FALLBACK = {
  self_declaration: "store_document_process",
  document: "store_document_process",
  setup_data_settings: "store_document_process",
  coco_store_overview: "store_document_process",
  coco_bulk_payment: "store_document_process",
  coco_zone_assignment: "store_document_process",
  store_execution: "store_execution_process",
  user_creation: "store_execution_process",
  account_details: "store_execution_process",
  employee_master: "store_execution_process",
};

// Indexes every entry by module_name, nested ones included. Top-level entries
// are indexed first, so a nested entry never shadows a top-level one.
const indexPermissions = (permissions) => {
  const byName = {};
  let level = Array.isArray(permissions) ? permissions : [];
  while (level.length) {
    const next = [];
    level.forEach((item) => {
      if (item?.module_name && !(item.module_name in byName)) {
        byName[item.module_name] = item;
      }
      if (Array.isArray(item?.hasItems)) next.push(...item.hasItems);
    });
    level = next;
  }
  return byName;
};

const usePermissions = () => {
  const dispatch = useDispatch();
  const [permissionFn, setPermissionFn] = useState(() => () => ({}));

  useEffect(() => {
    const fetchPermissions = () => {
      dispatch(adminRolesAction(onSuccess, onError));
    };
    fetchPermissions();
    const intervalId = setInterval(fetchPermissions, 10 * 60 * 1000);
    // A role edited elsewhere (another tab, another admin) applies as soon as
    // this tab is looked at again, not only on the 10-minute refresh.
    const onVisible = () => {
      if (document.visibilityState === "visible") fetchPermissions();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", fetchPermissions);
    return () => {
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", fetchPermissions);
    };
  }, []);

  const onSuccess = (data) => {
    const permissions = data?.data || [];
    localStorage.setItem("permission", JSON.stringify(permissions));
    const byName = indexPermissions(permissions);
    const newPermissionFn = (section) => {
      const permission =
        byName[section] ?? byName[PERMISSION_FALLBACK[section]];
      return permission || {};
    };
    setPermissionFn(() => newPermissionFn);
  };

  const onError = (error) => {

  };

  return { permissionFn };
};

export default usePermissions;
